<div class="flex gap-4">
  <div class="w-2/3">
    <div class="flex gap-2">
      <div class="w-1/4">
        <form [formGroup]="form">
          <app-input-group>
            <label appLabel>{{ 'meter.commissioningDate' | translate }}</label>
            <input appInputDate formControlName="commissioningDate">
          </app-input-group>
        </form>
      </div>


      <div class="w-3/4 flex gap-2" [formGroup]="searchForm">
        <div class="w-1/3">
          <app-input-group>
            <label appLabel>{{ 'meter.meterNumber' | translate }}</label>
            <input type="text" appInput formControlName="meterNumber" [placeholder]="'meter.meterNumber' | translate">
          </app-input-group>
        </div>


        <div class="w-1/3">
          <app-input-group>
            <label appLabel>{{ 'meter.alternativeMeterNumber' | translate }}</label>
            <input type="text" appInput formControlName="alternativeMeterNumber" [placeholder]="'meter.alternativeMeterNumber' | translate">
          </app-input-group>
        </div>

        <div class="w-1/3">
          <app-input-group>
            <label appLabel>{{ 'meter.serialNumber' | translate }}</label>
            <input type="text" appInput formControlName="serialNumber" [placeholder]="'meter.serialNumber' | translate">
          </app-input-group>
        </div>
      </div>
    </div>
    <div>
      <button appButton (click)="table.search()">{{ 'common.search' | translate }}</button>
    </div>

    <div class="mt-4">
      <app-table
        #table
        [config]="meterSimpleTableConfig"
        (selectedElementsChange)="selectionChanged($event)"
      ></app-table>
    </div>
  </div>
  <div class="w-1/3 border-l border-gray-200 pl-4">
    <div class="font-semibold py-2 text-sm">
      {{ 'meterFrame.details' | translate }}
    </div>

    <app-input-group>
      <label appLabel>{{ 'meterFrame.title' | translate }}</label>
      <input appInput [ngModel]="meterFrame?.identification" readonly>
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'meter.currentMeter' | translate }}</label>
      <input appInput [ngModel]="meter?.meterNumber" readonly>
    </app-input-group>

    <div class="bg-gray-100 dark:bg-dark-border h-[1px] mt-4 mb-2"></div>

    <div class="font-semibold py-2 text-sm">
      {{ 'meter.newMeter' | translate }}
    </div>

    <form [formGroup]="form">
      <app-input-group>
        <label appLabel>{{ 'meter.meterNumber' | translate }}</label>
        <input appInput formControlName="meterNumber" [placeholder]="'meter.meterNumber' | translate" readonly>
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'meter.meterId' | translate }}</label>
        <input appInput formControlName="meterId" [placeholder]="'meter.meterId' | translate" readonly>
      </app-input-group>


      <app-input-group>
        <label appLabel>{{ 'meter.alternativeMeterNumber' | translate }}</label>
        <input appInput formControlName="alternativeMeterNumber" [placeholder]="'meter.alternativeMeterNumber' | translate" readonly>
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'meter.serialNumber' | translate }}</label>
        <input appInput formControlName="serialNumber" [placeholder]="'meter.serialNumber' | translate" readonly>
      </app-input-group>
    </form>
  </div>
</div>
